import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from '@/utills/axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/permission'
import publicFun from './utills/publicFun'
import JSEncrypt from "jsencrypt"; //引入模块
Vue.prototype.$jsEncrypt = JSEncrypt; //配置全局变量
Vue.prototype.$axios = axios
Vue.prototype.publicFun = publicFun
Vue.use(ElementUI);
// 引入百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'bpMWE1pc7wpBVUNsSllTffzUL3sndTjk'  //这个地方是官方提供的ak密钥
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')